import jQuery from 'jquery';

const { UI } = Mobi2Go;

UI.View({
    name: 'headoffice_about',
    el: '[data-view="headoffice-about"]',
    template: jQuery('[data-template="headoffice-about"]').html(),
    initialise() {
        this.$el.html(this.template(Mobi2Go));

        if (Mobi2Go.headoffice.about) {
            jQuery('[data-view="headoffice-about-container"]').removeClass(
                'm2g-about--no-about-text'
            );
        }
    },
    model_listeners: {},
    DOM_listeners: {},
});
